import * as types from "./actionTypes";


export function updateHamburgerMenuStatus(status) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_HAMBURGER_MENU_STATUS,
      status
    });
  };
}

export function updateTheme(theme) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_THEME,
      theme
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/navigationActions.js